import React, { useState, useEffect } from "react";
import couponImg from "./images/coupon.png";

function CouponPopup() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.popup}>
        <button style={styles.close} onClick={() => setShow(false)}>
          ✕
        </button>

        <img class="popup"
          src={couponImg}
          alt="Coupon Banner"
          style={{ width: "350px", height: "350px" }}
        />
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  popup: {
    background: "#fff",
    padding: "15px",
    borderRadius: "10px",
    position: "relative",
  },
  close: {
    position: "absolute",
    top: "-3px",
    right: "0px",
    border: "none",
    background: "transparent",
    fontSize: "14px",
    cursor: "pointer",
  },
};

export default CouponPopup;